import React from "react";
import { Navigate } from "react-router-dom"; // Make sure to import Navigate

const isAuthenticated = () => {
  const storedToken = localStorage.getItem("authToken");
  const expectedToken = btoa(
    process.env.REACT_APP_USERNAME + ":" + process.env.REACT_APP_PASSWORD
  );

  if (storedToken !== expectedToken) {
    localStorage.removeItem("authToken");
    return false;
  }

  return true;
};

const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/login" replace />;
  }

  return children; // If authenticated, render the child components
};

export default ProtectedRoute;
